(() => {
  'use strict';
  if (window.HebesoCartPricing) return;
  const node = document.querySelector('#hebeso-cart-pricing-data');
  if (!node) return;
  const config = JSON.parse(node.textContent);
  const shippingThreshold = Math.max(100, Number(config.shippingThreshold) || 7000);
  const eligibleIds = new Set(config.variantIds.map(String));
  const legacyCodes = new Set(config.legacyCodes.map(code => code.toUpperCase()));
  let state = { items: [], total_price: 0 };
  let revision = 0;
  const tier = count => count >= 5 ? 15 : count >= 4 ? 12 : count >= 3 ? 9 : count >= 2 ? 5 : 0;
  const eligible = line => eligibleIds.has(String(line.variant_id ?? line.variantId ?? line.id)) && !line.selling_plan_allocation && !line.selling_plan;
  const count = lines => lines.reduce((sum, line) => sum + (eligible(line) ? line.quantity : 0), 0);
  const amount = (line, rate) => {
    const original = (line.original_price ?? line.price) * line.quantity;
    return eligible(line) ? Math.round(original * (100 - rate) / 100) : (line.final_line_price ?? original);
  };
  function quote(selection, cart = state, excludedGroup = null) {
    const others = cart.items.filter(line => !excludedGroup || line.properties?._hebeso_set_id !== excludedGroup);
    const selectedCount = selection.reduce((sum, line) => sum + line.quantity, 0);
    const existingCount = count(others);
    const eligibleCount = existingCount + count(selection);
    const cartRate = tier(eligibleCount);
    const rate = count(selection) ? cartRate : 0;
    const original = selection.reduce((sum, line) => sum + line.price * line.quantity, 0);
    const total = selection.reduce((sum, line) => sum + amount(line, cartRate), 0);
    const otherTotal = others.reduce((sum, line) => sum + amount(line, cartRate), 0);
    const cartSubtotal = total + otherTotal;
    const cartSaving = [...selection,...others].filter(eligible).reduce((sum,line) => sum + (line.original_price ?? line.price) * line.quantity - amount(line,cartRate), 0);
    const shipping = cartSubtotal === 0 || cartSubtotal >= shippingThreshold ? 0 : 590;
    return { count:selectedCount, existingCount, eligibleCount, cartRate, rate, original, total,
      saving:original-total, otherTotal, cartSubtotal, cartSaving,
      shipping, delivered:total+shipping, cartDelivered:cartSubtotal+shipping };
  }
  function setCart(next) {
    if (!next || !Array.isArray(next.items)) return state;
    revision++;
    state = next;
    document.dispatchEvent(new CustomEvent('hebeso:pricing-updated', { detail:state }));
    return state;
  }
  function retainedCodes(cart) {
    const codes = new Set((cart.discount_codes || []).map(entry => entry.code).filter(Boolean));
    for (const line of cart.items || []) for (const allocation of line.line_level_discount_allocations || []) {
      if (allocation.discount_application?.type === 'discount_code') codes.add(allocation.discount_application.title);
    }
    return { all:[...codes], keep:[...codes].filter(code => !legacyCodes.has(code.toUpperCase())) };
  }
  async function request(endpoint, body) {
    const response = await fetch(config.root + endpoint, {
      method:body === undefined ? 'GET' : 'POST', credentials:'same-origin', cache:'no-store',
      headers:{Accept:'application/json', ...(body === undefined ? {} : {'Content-Type':'application/json'})},
      ...(body === undefined ? {} : {body:JSON.stringify(body)}), hebesoCartInternal:true
    });
    const result = await response.json();
    if (!response.ok || result.status >= 400) throw new Error(result.description || config.strings.load_error);
    return result;
  }
  async function refresh() {
    const started = ++revision;
    let next = await request('cart.js');
    const codes = retainedCodes(next);
    if (codes.keep.length !== codes.all.length) {
      await request('cart/update.js', {discount:codes.keep.join(',')});
      next = await request('cart.js');
    }
    if (started === revision) setCart(next);
    return state;
  }
  window.HebesoCartPricing = Object.freeze({tier, eligible, count, quote, setCart, refresh,
    getCart:() => state, strings:config.strings, retainedCodes});
  const initial = document.querySelector('[data-hbc-cart-state]');
  if (initial) {
    try { setCart(JSON.parse(initial.textContent)); } catch {}
  }
})();
